module.exports = __webpack_public_path__ + "img/telemedicine3.b52ae12e.webp";